import api from './api';

const assetMaintenanceService = {
  // Get all maintenance records
  getAllMaintenance: async (params = {}) => {
    try {
      const response = await api.get('/asset-maintenance', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching asset maintenance records:', error);
      throw error;
    }
  },

  // Get maintenance record by ID
  getMaintenanceById: async (id) => {
    try {
      const response = await api.get(`/asset-maintenance/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching asset maintenance record:', error);
      throw error;
    }
  },

  // Create maintenance record
  createMaintenance: async (data) => {
    try {
      const response = await api.post('/asset-maintenance', data);
      return response.data;
    } catch (error) {
      console.error('Error creating asset maintenance record:', error);
      throw error;
    }
  },

  // Update maintenance record
  updateMaintenance: async (id, data) => {
    try {
      const response = await api.put(`/asset-maintenance/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating asset maintenance record:', error);
      throw error;
    }
  },

  // Delete maintenance record
  deleteMaintenance: async (id) => {
    try {
      const response = await api.delete(`/asset-maintenance/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting asset maintenance record:', error);
      throw error;
    }
  },

  // Get maintenance statistics
  getMaintenanceStats: async () => {
    try {
      const response = await api.get('/asset-maintenance/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching asset maintenance statistics:', error);
      throw error;
    }
  },

  // Get next maintenance code
  getNextMaintenanceCode: async () => {
    try {
      const response = await api.get('/asset-maintenance/next-code');
      return response.data;
    } catch (error) {
      console.error('Error fetching next maintenance code:', error);
      throw error;
    }
  }
};

export default assetMaintenanceService;
